import { gql } from '@apollo/client';

export const GET_EXCHANGE_RATES = gql`
  query GetExchangeRates {
    getExchangeRates {
      id
      rate
      target
      source
    }
  }
`;
